import { useSelector } from 'react-redux'
import { ProductData } from 'lib/types'
import { getStoreTimezone } from 'lib/core/data/common/storeConfig/selectors'
import { getAddProduct } from 'lib/core/data/quote/addProduct/selectors'
import { DateTime } from 'luxon'

interface ProductStatus {
  getIsSale: () => boolean
  getIsNew: () => boolean
  isAddingToCart: boolean
}

export const useProductStatus = (product: ProductData): ProductStatus => {
  const timezone = useSelector(getStoreTimezone)
  const { isFetching: isAddingToCart } = useSelector(getAddProduct((product.sku)))

  return {
    getIsSale: () => {
      return getIsSale(product)
    },

    getIsNew: () => {
      return getIsNew(product, timezone)
    },

    isAddingToCart
  }
}

const getIsNew = (product?: ProductData, timezone?: string): boolean => {
  if (!timezone || !product) {
    return false
  }

  const {
    newFromDate: from,
    newToDate: to
  } = product

  let isNew = false

  if (from) {
    const dateNow = DateTime.local().setZone(timezone)
    const dateFrom = DateTime.fromISO(from.replace(' ', 'T')).setZone(timezone)

    if (dateFrom <= dateNow) {
      isNew = true
    }

    if (isNew && to) {
      const dateTo = DateTime.fromISO(to.replace(' ', 'T')).setZone(timezone)
      if (dateTo >= dateNow) {
        isNew = false
      }
    }
  }

  return isNew
}

const getIsSale = (product?: ProductData) => {
  if (!product) {
    return false
  }

  const { price } = product
  const { regularPrice, maximalPrice } = price || {}
  const { amount: amountRegular } = regularPrice || {}
  const { amount: amountMaximal } = maximalPrice || {}
  const { value: valueRegular } = amountRegular || {}
  const { value: valueMaximal } = amountMaximal || {}
  const hasSpecialPrice = valueMaximal < valueRegular

  return hasSpecialPrice
}
